<template>
  <div class="my-4 border-0 border-t border-solid border-gray-200"></div>
</template>